import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { translationResources } from "./resources";

const stored = typeof window !== "undefined" ? localStorage.getItem("xentros_lang") : null;
const normalizedStored = stored?.trim().toLowerCase() ?? null;
const lng = normalizedStored && ["de", "en", "pl", "fr"].includes(normalizedStored)
  ? normalizedStored
  : "de";

i18n.use(initReactI18next).init({
  resources: translationResources,
  lng,
  fallbackLng: "en",
  interpolation: { escapeValue: false }, 
});

export default i18n;
